import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import {
  SiStripe,
  SiShopify,
  SiHubspot,
  SiAsana,
  SiNotion,
  SiZapier,
  SiIntercom,
  SiLinear,
} from "react-icons/si";

const BRANDS = [
  { name: "Stripe", Icon: SiStripe },
  { name: "Shopify", Icon: SiShopify },
  { name: "HubSpot", Icon: SiHubspot },
  { name: "Asana", Icon: SiAsana },
  { name: "Notion", Icon: SiNotion },
  { name: "Zapier", Icon: SiZapier },
  { name: "Intercom", Icon: SiIntercom },
  { name: "Linear", Icon: SiLinear },
];

export default function TrustMarquee() {
  return (
    <section
      className="relative border-y border-white/5 bg-[#070818]/60 py-14"
      data-testid="trust-banner"
    >
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="mb-10 text-center text-xs font-semibold uppercase tracking-[0.24em] text-slate-500"
      >
        Trusted by{" "}
        <span className="text-teal-300">500+</span> fast-growing startups and
        digital brands
      </motion.p>

      <div data-testid="trust-marquee">
        <Marquee speed={28} gradient gradientColor="#070818" gradientWidth={140}>
          {BRANDS.map(({ name, Icon }) => (
            <div
              key={name}
              className="mx-10 flex items-center gap-3 opacity-40 transition-opacity duration-500 hover:opacity-90"
            >
              <Icon className="h-6 w-6 text-slate-300" />
              <span className="font-display text-lg font-medium tracking-tight text-slate-300">
                {name}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
